import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import PurchaseDetailModal from "../Modal/DetailModal"
import FilterCustom from "./Filter"
import ViewSimDetailModal from "../../SalesReport/Modal/ViewSimDetailModal"

function ListPurchase({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
  setExcelKeyword,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isSimModalOpen, setIsSimModalOpen] = useState(false)

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setParentFilter(filter)
    setExcelKeyword(keyword)
    try {
      const res = await ReportsService.getListBuy({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        // console.log("API trả về:", res.success.data);
        const formatted = res?.success?.data.map((item, index) => ({
          ...item,
          ID: item.ID,
          key: item.ID || index,
          export_id: item.export?.ID || "",
          order_code: item.export?.export_code || "",
          customer_name: item.customer?.fullname || "",
          vat: Number(item.vat),
          quantity: item.quantity || 0,
          update_at: item.updated_at || "",
          supplier: item.supplier?.name || "",
          currency_type: item.currency_type || "",
          unit_price: item.unit_price ? Number(item.unit_price) : 0,
          end_price: item.end_price ? Number(item.end_price) : 0,
          sim_fee: item.sim_fee ? Number(item.sim_fee) : 0,
          package_unit_price: item.package_unit_price
            ? Number(item.package_unit_price)
            : 0,
          total_after_vat: item.total_after_vat
            ? Number(item.total_after_vat)
            : 0,
          total_before_vat: item.total_before_vat
            ? Number(item.total_before_vat)
            : 0,
        }))

        setDataSource(formatted)
        setSummary({
          total_quantity: Number(
            res?.success?.amount?.total_quantity || 0,
          ).toLocaleString("en-US"),
          total_unit_price: Number(
            res?.success?.amount?.total_unit_price || 0,
          ).toLocaleString("en-US"),
          total_end_price: Number(
            res?.success?.amount?.total_end_price || 0,
          ).toLocaleString("en-US"),
          total_connection_fee: Number(
            res?.success?.amount?.total_connection_fee || 0,
          ).toLocaleString("en-US"),
          total_package_unit_price: Number(
            res?.success?.amount?.total_package_unit_price || 0,
          ).toLocaleString("en-US"),
          total_sim_fee: Number(
            res?.success?.amount?.total_sim_fee || 0,
          ).toLocaleString("en-US"),
          total_vat: Number(
            res?.success?.amount?.total_vat || 0,
          ).toLocaleString("en-US"),
          total_after_vat: Number(
            res?.success?.amount?.total_after_vat || 0,
          ).toLocaleString("en-US"),
          total_before_vat: Number(
            res?.success?.amount?.total_before_vat || 0,
          ).toLocaleString("en-US"),
          usim: res?.success?.Sim?.usim || 0,
          esim: res?.success?.Sim?.esim || 0,
        })
        setPagination({
          ...pagination,
          total: res.success.total,
        })
      }
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  useEffect(() => {
    setPagination({
      ...pagination,
      current: 1,
    })
  }, [filter])

  // mở modal seri SIM
  const handleOpenSimModal = record => {
    setSelectedRecord(record)
    setIsSimModalOpen(true)
  }

  const handleCloseModals = () => {
    setIsDetailModalOpen(false)
    setIsSimModalOpen(false)
    setSelectedRecord(null)
  }
  const handleOpenDetailModal = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }

  const columns = [
    // {
    //   title: "STT",
    //   dataIndex: "index",
    //   key: "index",
    //   align: "center",
    //   render: (text, record, index) =>
    //     (pagination.current - 1) * pagination.pageSize + index + 1,
    //   width: 60,
    // },
    {
      title: "Đơn hàng",
      dataIndex: "order_code",
      key: "order_code",
      align: "center",
      render: (text, record) => (
        <a
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenDetailModal(record)
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Khách hàng",
      dataIndex: "customer_name",
      key: "customer_name",
      align: "center",
    },
    {
      title: "Nhà cung cấp",
      dataIndex: "supplier",
      key: "supplier",
      align: "center",
    },
    {
      title: "Số lượng",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
      render: (value, record) => (
        <a
          style={{ color: "#28a745", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenSimModal(record)
          }}
        >
          {value}
        </a>
      ),
    },
    // {
    //   title: "Phí SIM",
    //   dataIndex: "sim_fee",
    //   align: "center",
    //   render: text => Number(text).toLocaleString(),
    // },
    // {
    //   title: "Giá gói cước",
    //   dataIndex: "package_unit_price",
    //   key: "package_unit_price",
    //   align: "center",
    //   render: text => Number(text).toLocaleString(),
    // },

    // {
    //   title: "Phí hòa mạng",
    //   dataIndex: "connection_fee",
    //   key: "connection_fee",
    //   align: "center",
    //   render: text => Number(text).toLocaleString(),
    // },
    {
      title: "Tổng tiền trước VAT",
      dataIndex: "total_before_vat",
      key: "total_before_vat",
      align: "center",
      render: value =>
        value ? new Intl.NumberFormat().format(Number(value)) : "",
    },
    {
      title: "VAT (%)",
      dataIndex: "vat",
      align: "center",
    },
    {
      title: "Tổng tiền sau VAT",
      dataIndex: "total_after_vat",
      key: "total_after_vat",
      align: "center",
      render: value =>
        value ? new Intl.NumberFormat().format(Number(value)) : "",
    },
    {
      title: "Loại chiết khấu",
      dataIndex: "discount_type",
      align: "center",
      render: value => {
        if (value === "percent") return "Trước VAT"
        if (value === "fixed") return "Sau VAT"
        return value
      },
    },
    {
      title: "Tỷ lệ chiết khấu",
      dataIndex: "discount",
      align: "center",
      render: value => {
        return value + "%"
      },
    },
    {
      title: "Giá sau chiết khấu",
      dataIndex: "end_price",
      key: "end_price",
      align: "center",
      render: value =>
        value ? new Intl.NumberFormat().format(Number(value)) : "",
    },
    {
      title: "Loại tiền tệ",
      dataIndex: "currency_type",
      align: "center",
      render: value => {
        if (value === "vnd") return "VND"
        if (value === "usd") return "USD"

        return value
      },
    },
    {
      title: "Ngày duyệt nhập kho",
      dataIndex: "update_at",
      key: "update_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        <FilterCustom
          setFilter={setFilter}
          setKeyword={setKeyword}
          // tabStatus={tabStatus}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng số SIM: {summary?.total_quantity}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#6f42c1", minWidth: "150px" }}>
          <strong>Tổng USIM: {summary?.usim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#fd7e14", minWidth: "150px" }}>
          <strong>Tổng ESIM: {summary?.esim}</strong>
        </div>
        {/* <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>
            Tổng tiền trước chiết khấu: {summary.total_unit_price}
          </strong>
        </div> */}
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tổng tiền sau chiết khấu: {summary.total_end_price}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#17a2b8", minWidth: "150px" }}>
          <strong>Tổng phí SIM: {summary.total_sim_fee}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#ffc107", minWidth: "150px" }}>
          <strong>Tổng phí gói cước: {summary.total_package_unit_price}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#6610f2", minWidth: "150px" }}>
          <strong>Tổng phí hoà mạng: {summary.total_connection_fee}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#e83e8c", minWidth: "150px" }}>
          <strong>Tổng tiền trước VAT: {summary.total_before_vat}</strong>
        </div>
        <div
          style={{ padding: "0 5px", color: "#5d269cff", minWidth: "150px" }}
        >
          <strong>Tổng tiền sau VAT: {summary.total_after_vat}</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={columns}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: event => {
        //       handleRowClick(record?.ID)
        //     },
        //   }
        // }}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {selectedRecord && (
        <PurchaseDetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseModals}
          recordId={selectedRecord.ID}
        />
      )}
      {isSimModalOpen && (
        <ViewSimDetailModal
          visible={isSimModalOpen}
          onClose={handleCloseModals}
          id={selectedRecord?.ID}
          api={ReportsService.detailSimPurchase}
          historyDetail={false}
        />
      )}
    </div>
  )
}

export default ListPurchase
